import API_URL from "@/constant/api.config";
import { setAuthHeaders } from "@/utils/common";
import axiosInstance from '../axiosHttp';

export const productList = (data) => async (dispatch) => {

    const headers = setAuthHeaders();
    headers['Content-Type'] = 'multipart/form-data';

    return await axiosInstance.post(API_URL + '/product/list', data, { headers }).then((response) => {
        // console.log(" API response in userAction File ", response);
        console.log("Response >>>>>>>>> ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}


export const createProduct = (data) => async (dispatch) => {

    const headers = setAuthHeaders();
    headers['Content-Type'] = 'multipart/form-data';

    return await axiosInstance.post(API_URL + '/product/add', data, { headers }).then((response) => {
        // console.log(" API response in userAction File ", response);
        console.log("Response >>>>>>>>> ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}


export const getProduct = (id) => async (dispatch) => {

    const headers = setAuthHeaders();

    return await axiosInstance.get(API_URL + "/product/" + id, {
        headers
    })
        .then((response) => {
            // console.log('response======', response.data.data);
            return response.data;
        })
        .catch((error) => {
            console.log("Error ========== ", error);
        });
}

export const deleteProduct = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.delete(API_URL + '/destroy-product/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const updateProduct = (id, data) => async (dispatch) => {

    const headers = setAuthHeaders();
    headers['Content-Type'] = 'multipart/form-data';

    return await axiosInstance.post(API_URL + '/product/updates/' + id, data, { headers }).then((response) => {
        // console.log(" API response in userAction File ", response);
        console.log("Response >>>>>>>>> ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}

export const deleteProductMedia = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.delete(API_URL + '/destroy-product-media/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const updateproductStatus = (data) => () => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/product/update-status', data, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error === ", err);
    })
}








